<!-- apps/frontend/src/components/flow/nodes/WaitForUserReplyNode.vue -->
<template>
  <div :class="['group bg-gray-700 border-2 rounded-lg shadow-lg w-64 relative overflow-visible',
                selected ? 'border-cyan-400' : data.__validationError ? 'border-red-500' : 'border-gray-600']">
    <div class="bg-gray-800 p-3 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-cyan-400">hourglass_empty</span>
        <strong class="text-white text-sm">{{ $t('flowEditor.palette.waitForUserReply') }}</strong>
      </div>
      <ValidationMarker :error="data.__validationError" />
    </div>
    <div class="p-3">
      <p class="text-gray-400 text-xs truncate">{{ data.variableName || $t('flowEditor.waitForUserReplyEditor.noVariable') }}</p>
    </div>
    <Handle type="target" :position="Position.Left" />
    <Handle type="source" :position="Position.Right" />
    <AddNodeButton v-if="!hasOutgoingEdge" @add="emit('add-node', nodeId)" />
  </div>
</template>
<script setup>
import { Handle, Position } from '@vue-flow/core';
import AddNodeButton from './AddNodeButton.vue';
import ValidationMarker from './ValidationMarker.vue';
const emit = defineEmits(['add-node']);
defineProps({
  data:            { type: Object,  required: true },
  selected:        { type: Boolean, default: false },
  nodeId:          { type: String,  required: true },
  hasOutgoingEdge: { type: Boolean, default: false },
});
</script>
